/** Shopify CDN: Minification failed

Line 31:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 38:28 Transforming array spread to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 32:28 Transforming array spread to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 19:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 26:28 Transforming array spread to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 20:28 Transforming array spread to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 7:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 14:28 Transforming array spread to the configured target environment ("es5") is not supported yet

**/
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
